export const INITIALISE_CARDO_LIST = 'BEAMLY/CCX/INITIALISE_CARDO_LIST';
export const SHOW_MORE_CARDO_LIST = 'BEAMLY/CCX/SHOW_MORE_CARDO_LIST';
export const HIDE_SHOW_MORE_CARDO_LIST = 'BEAMLY/CCX/HIDE_SHOW_MORE_CARDO_LIST';

export const initialiseCardoList = ({ id }) => ({
  type: INITIALISE_CARDO_LIST,
  id,
});

export const showMore = ({ id }) => ({
  type: SHOW_MORE_CARDO_LIST,
  id,
});

export const hideShowMore = ({ id }) => ({
  type: HIDE_SHOW_MORE_CARDO_LIST,
  id,
});
